import styled from "styled-components";

export const Container: any = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
  border-radius: 9.843px;
  background: #fff;
  box-shadow: 0px 1.85px 9.24px 0px rgba(0, 0, 0, 0.1);
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 700px;
  max-width: 700px;
`;

export const Badge: any = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #eaefff;
  padding: 8px 22px;
  border-radius: 30px;
  align-items: center;
  gap: 16px;
`;

export const BadgeText: any = styled.p`
  color: var(--Azul-Primary-500, #2d5bff);
  font-family: Inter;
  font-size: 27.158px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const LargeText: any = styled.p`
  color: var(--Cinza-Gray-400, #424248);
  text-align: center;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.24px;
  margin-top: 16px;
`;

export const LightText: any = styled.p`
  display: flex;
  flex-direction: row;
  color: var(--Cinza-Gray-400, #424248);
  text-align: center;
  font-family: Inter;
  font-size: 20.69px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 16px;
`;

export const StrongText: any = styled.p`
  color: var(--Cinza-Gray-400, #424248);
  font-family: Inter;
  font-size: 20.69px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-left: 8px;
`;
